import { EthicalGovernanceView } from "src/organisms/EthicalGovernanceView";
import { buildStaticProps } from "src/utils/static-props/app-page-props";

export default function EthicalGovernance(): JSX.Element {
  return <EthicalGovernanceView />;
}

export async function getStaticProps() {
  return buildStaticProps({});
}
